<template>
  <span :class="{'no-number': !formatedNumber}">
    <span v-if="formatedNumber">
      {{ formatedNumber }}
    </span>
    <span v-else>
      chybí číslo
    </span>
  </span>
</template>

<script>
import DataTypeProsMixin from 'CORE/mixins/dataType'
import _ from 'lodash'
import numeral from 'numeral'
import numeralCs from 'numeral/locales/cs'
numeral.locale('cs')

export default {
    name: 'NumericDetail',
    mixins: [
        DataTypeProsMixin,
    ],
    computed: {
        formatedNumber() {
            let number = _.get(this.value, 'value.value.number', undefined)
            let unit = _.get(this.value, 'value.value.unit', undefined)
            const convert = _.get(this.propertyType, 'settings.numeric.convertToDefault', false)
            const isProgress = _.get(this.propertyType, 'settings.systags.progress', false)

            if (_.isNumber(number)) {
                if (convert) {
                    const currentOption = _.head(_.filter(_.get(this.propertyType, 'settings.numeric.unitsOptions', []), o => o.shortcut === unit))
                    const defaultOption = _.head(_.filter(_.get(this.propertyType, 'settings.numeric.unitsOptions', []), o => o.default === true))

                    const multiplier = _.toNumber(_.get(currentOption, 'multiplier', 1))

                    number = number * multiplier
                    unit = defaultOption.shortcut
                }
                if (isProgress) {
                    return `${number}%`
                }
                if (unit) {
                    return `${numeral(number).format('0,0.[0000]')} ${unit}`
                } else {
                    return `${numeral(number).format('0,0.[0000]')}`
                }
            }
            return false
        },
    },
}
</script>

<style>
.no-number {
    color: DarkGray;
    font-style: italic;
    font-size: 80%;
}
</style>
